import React, { ReactElement, useMemo } from 'react';
import { Bucket } from './Bucket';
import { PropertyOccupancy } from '../ReportRevenue/PropertyOccupancy';
import {
  BucketData,
  TaxLicenseError,
  TaxReportLicense,
} from 'src/types/tax';
import { BucketGroupWrapper } from './BucketGroupWrapper';

interface BucketGroupProps {
  buckets: Array<BucketData>;
  error?: TaxLicenseError;
  hideOccupancy?: boolean;
  name: string;
  title: string;
  values: TaxReportLicense;
  isMobile?: boolean;
}

export const BucketGroup = ({
  buckets,
  error,
  hideOccupancy,
  isMobile,
  name,
  title,
  values,
}: BucketGroupProps): ReactElement => {
  const dirty = useMemo(() => {
    return (
      values.occupancy.available !== undefined ||
      values.occupancy.occupied !== undefined ||
      values.buckets.some(
        (bucket) =>
          bucket.discounts !== undefined || bucket.revenue !== undefined
      )
    );
  }, [values.occupancy.available, values.occupancy.occupied, values.buckets]);

  const isCompleted = useMemo(() => {
    return (
      dirty &&
      (!error ||
        (error?.buckets.every(
          (bucket) => !bucket.discounts && !bucket.revenue
        ) &&
          !error.occupancy.available &&
          !error.occupancy.occupied))
    );
  }, [error, dirty]);

  return (
    <BucketGroupWrapper
      collapsible={!isMobile}
      isCompleted={isCompleted}
      title={title}
    >
      {!hideOccupancy && (
        <PropertyOccupancy
          name={name}
          error={error?.occupancy}
          value={values?.occupancy}
        />
      )}
      {buckets.map((bucket, index) => (
        <Bucket
          isMobile={isMobile}
          key={`${name}.buckets[${index}]`}
          name={`${name}.buckets[${index}]`}
          title={bucket.label}
          value={values?.buckets[index]}
          error={error?.buckets?.[index]}
          deductionsConfig={bucket.deductionsConfig}
        />
      ))}
    </BucketGroupWrapper>
  );
};
